// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about figure {\n  float: right;\n  height: 200px;\n  width: 200px;\n  border-radius: 50%;\n  -webkit-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.3);\n  -moz-box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n.about figure img {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
